import { render, staticRenderFns } from "./TmsDebrief.vue?vue&type=template&id=136ba6ad&scoped=true&"
import script from "./TmsDebrief.vue?vue&type=script&lang=js&"
export * from "./TmsDebrief.vue?vue&type=script&lang=js&"
import style0 from "./TmsDebrief.vue?vue&type=style&index=0&id=136ba6ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136ba6ad",
  null
  
)

export default component.exports